const FTproblemStatements = [
  {
    statementId: "FT1",
    problemStatement:
      "In today’s digital world, managing daily expenses can be tedious, as users must manually log each transaction. This makes tracking inconsistent and time-consuming. Imagine a system where users simply send a message like 'Paid ₹50 for food via UPI,' and it’s instantly recorded, categorized, and updated in a real-time dashboard making expense tracking effortless.",
    exampleFeatures: [
      "Chat Input Interface: Users can log expenses by sending natural language messages through WhatsApp or Telegram bots.",
      "Automatic Expense Logging: The system parses messages and records transactions instantly without manual entry.",
      "Smart Categorization: Automatically classifies expenses like food, travel, bills, shopping, etc.",
      "Real-Time Dashboard: A web dashboard provides insights into daily, weekly, and monthly spending patterns.",
      "Search & History: Users can retrieve past transactions via chat commands or view detailed history on the dashboard."
    ],
    extracontent:
      "Focus on effortless expense tracking through chat, not traditional apps."
  },
  {
    statementId: "FT2",
    problemStatement:
      "In today’s financial landscape, many individuals struggle to assess loan affordability and eligibility. This leads to poor borrowing decisions and financial stress. Imagine a smart assistant that analyzes your financial profile and provides personalized guidance helping you make safe and informed borrowing decisions.",
    exampleFeatures: [
      "Financial Input System: Users can enter salary, monthly expenses, existing obligations, and financial goals.",
      "EMI Affordability Calculator: Calculates how much EMI the user can comfortably pay without financial strain.",
      "Loan Eligibility Estimation: Provides an estimate of loan amount users are eligible for based on their profile.",
      "Monthly Budget Breakdown: Shows how loan repayment fits into overall monthly expenses.",
      "Risk Indicator: Highlights chances of over-borrowing and financial stress.",
      "Safe EMI Suggestions: Recommends EMI ranges that minimize risk."
    ],
    extracontent:
      "Focus on smart financial decision-making, not just basic loan calculation."
  },
  {
    statementId: "FT3",
    problemStatement:
      "In today’s digital world, managing group expenses among friends, roommates, or travel groups often becomes confusing and inefficient. People struggle to keep track of who paid, who owes whom, and how to settle balances fairly. Existing solutions simply split bills but fail to reduce complexity in settlements. Imagine a system that intelligently analyzes expenses, minimizes transactions, and provides a clear, optimized settlement plan in the simplest way possible.",
    exampleFeatures: [
      "Group Expense Entry: Users can add shared expenses manually or through chat-based input.",
      "Auto Split Engine: Automatically divides expenses among participants.",
      "Settlement Optimizer: Minimizes the number of transactions by optimizing payment flow.",
      "Fairness Adjustments: Supports unequal splits for realistic scenarios.",
      "Visual Debt Graph: Clearly shows who owes whom.",
      "One-Click Settlement Plan: Generates an optimized step-by-step settlement."
    ],
    extracontent:
      "Focus on reducing complexity in group finance through intelligent settlement optimization, not just basic expense splitting."
  },
  {
    statementId: "FT4",
    problemStatement:
      "In today’s digital world, scams like fake calls and phishing are increasingly common, and many fall victim due to lack of awareness. Existing methods are passive and don’t prepare users for real situations. Imagine an interactive platform that simulates real scam scenarios helping users identify threats and respond safely.",
    exampleFeatures: [
      "Simulated Scam Scenarios: Users receive realistic fake calls, SMS, or chat messages mimicking common scams.",
      "Interactive Decision-Making: Users choose how to respond in each scenario, making it a hands-on learning experience.",
      "Real-Time Red Flag Detection: Highlights suspicious elements such as unknown links, urgency, or threats during simulation.",
      "Awareness Tips & Guides: Provides educational content on how to identify and avoid scams.",
      "Performance Score & Feedback: Gives users a score and detailed feedback after each simulation."
    ],
    extracontent:
      "Focus on experiential learning through simulation, not just passive awareness."
  }
];

export default FTproblemStatements;